/**
 * 引用环境变量配置的变量
 */
export default {
  /**
   * Api 根目录
   */
   // ApiRoot: process.env.VUE_APP_API_ROOT,
    ApiRoot: 'http://47.95.223.196:9210',
   // ApiRoot: 'http://127.0.0.1:9210',
   // ApiRoot: 'http://118.119.9.140:8090/bookService',
  /**
   * 资源服务根目录（图片，视频等)
   */

  ResRoot: process.env.VUE_APP_API_ROOT,
  // BIMV地址
  apiDomain: process.env.VUE_APP_API_DOMAIN,
  /**
   * 文件上传的接口路径
   */
  UploadUrl: `${process.env.VUE_APP_API_ROOT}/file`,

  // rsa公钥密码ti
  publicKey: `-----BEGIN PUBLIC KEY-----
  MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCSNJV8Ioh9dmZGjBStHR3xB5kU
  x2mzujGTr/6LK/tbnzgikgSBrllKRQpycH+/nXpAO/MLXrP/AFtNLtqdaQ5FES4S
  Mf34CQKcKiTRSkpN+jvYF1nh4krem4voluaXsAs/WCAWUhHXq0C4HmhbsF+B8EIv
  L/Du3DXsrB5H1rz/hQIDAQAB
  -----END PUBLIC KEY-----`
}
